import { GetServerSidePropsContext } from "next";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";

import { discussionUrl as getDiscussionUrl } from "components/DiscussionModal";
import EntityPageContainer from "components/EntityPageLayout";
import { entityLayoutData } from "components/EntityPageLayout/entityLayoutData";
import EntityPageDiscussions from "components/EntityPageLayout/EntityPageDiscussions";
import { entityDiscussionsUrl } from "components/EntityPageLayout/EntityPageDiscussions/EntityPageDiscussionsList";
import type { NextPageWithLayout } from "pages/_app";
import { baseFetcher } from "utils/baseFetcher";
import { isSsr } from "utils/isSsr";

const EntityInsightsTabPage: NextPageWithLayout = () => {
  return <EntityPageDiscussions />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const slug = context.params?.slug as string;
    const discussionId = context.query.discussion as string;

    const discussionsUrl = entityDiscussionsUrl(slug, 1);
    const discussionUrl = getDiscussionUrl(discussionId);

    const [{ entity, entityLayoutFallback }, discussions, discussion] =
      await Promise.all([
        entityLayoutData(slug, context),
        isSsr(context)
          ? baseFetcher(discussionsUrl, context)
          : Promise.resolve({}),
        isSsr(context) && discussionId
          ? baseFetcher(discussionUrl, context)
          : Promise.resolve({}),
      ]);

    if (!entity || entity.errors?.length) return { notFound: true };

    return {
      props: {
        slug,
        entity,
        fallback: {
          ...entityLayoutFallback,
          [`$inf$${discussionsUrl}`]: [discussions],
          [discussionUrl]: discussion,
        },
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps entity discussions Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return { notFound: true };
  }
}

EntityInsightsTabPage.getLayout = (page, { pageProps }) => {
  const { fallback } = pageProps;

  return (
    <SWRConfig value={{ fallback }}>
      <EntityPageContainer {...pageProps}>{page}</EntityPageContainer>
    </SWRConfig>
  );
};

export default EntityInsightsTabPage;
